// extracted by mini-css-extract-plugin
export default {"darkGrey300":"#a2b8c5","coloredBg":"Simple_coloredBg__sTJ98"};